"use client";

import { c as _c } from "react/compiler-runtime";
export default function HeroHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="tw-px-4 tw-pt-16 md:tw-px-6 lg:tw-px-8 lg:tw-text-center"><p className="tw-mb-2 tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-[0.2em] tw-text-iron-500">6529 Seize</p><h1 className="tw-mb-3 tw-text-3xl tw-font-bold tw-leading-tight tw-tracking-tight tw-text-iron-200 md:tw-text-4xl">Where art meets community</h1></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}